import { createStore, applyMiddleware } from 'redux';

// IMPORT MIDDLEWARE
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';

// IMPORT REDUCERS
import { AppReducer } from '../reducers/AppReducer';

// CONFIGURE STORE
export const createAppStore = () => createStore(AppReducer, applyMiddleware(thunkMiddleware, promiseMiddleware()));



// WEBPACK FOOTER //
// ./src/stores/AppStore.js